import React from 'react';

import Cell from './Cell';
import RowMenu from '../RowMenu';

export default function Row({ cols, row, actions }) {
  return (
    <tr className="border-b dark:border-gray-700">
      {cols.map((col) => {
        return <Cell key={col.key} row={row} col={col} />;
      })}

      {actions.length ? (
        <td className="px-4 py-3 flex items-center justify-end">
          <RowMenu actions={actions} row={row} />
        </td>
      ) : null}
    </tr>
  );
}
